// extracted by mini-css-extract-plugin
export var body = "Text--body--LbB3W";
export var margin = "Text--margin--+4Nkf";
export var marginBottom = "Text--marginBottom--TDFsM";
export var tkMyriadProSemiCondensed = "Text--tk-myriad-pro-semi-condensed--ro6ZL";